import clsx from "clsx";
import type { ReactNode } from "react";

/**
 * Data table primitives per 10_component-anatomy.md section 4: a 2px --border-strong header rule
 * on a tinted header ground (--bg-elevated on dark, #ECEDEF on light), 1px --border-strong row
 * rules, --space-3 / --space-4 cell padding, no banding. Wrap in a Card.
 */
export function Table({ children, caption, className }: { children: ReactNode; caption?: string; className?: string }) {
  return (
    <div className="overflow-x-auto">
      <table className={clsx("w-full border-collapse text-body", className)}>
        {caption && <caption className="mb-3 text-left text-small text-ink-secondary">{caption}</caption>}
        {children}
      </table>
    </div>
  );
}

export function Th({ children, className }: { children: ReactNode; className?: string }) {
  return <th className={clsx("border-b-2 border-rule-strong bg-card-tinted px-4 py-3 text-left font-semibold text-anchor", className)}>{children}</th>;
}

export function Td({ children, className, colSpan }: { children?: ReactNode; className?: string; colSpan?: number }) {
  return (
    <td colSpan={colSpan} className={clsx("border-b border-rule-strong px-4 py-3 align-top", className)}>
      {children}
    </td>
  );
}
